import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { CUSTOM_CONFIRM_TYPES, Can, CustomConfirm } from "components";
import { usePermanentRealTimeUser } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES, ROLES } from "models";
import { useDeleteDealerMutation } from "modules/DealerDetails/components/DealerDetailsActions/hooks";
import { PATHS } from "router/paths";

import type { DealerID } from "models";

type DealerDetailsActionsProps = {
  dealerId: DealerID;
  dealerName: string;
};

export const DealerDetailsActions = ({ dealerId, dealerName }: DealerDetailsActionsProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

  const { user } = usePermanentRealTimeUser();
  const { mutate: deleteDealer, isPending: isDeleteDealerPending } = useDeleteDealerMutation();

  if (user?.role_id !== ROLES.SuperAdmin) return null;

  return (
    <Can I={ACL_ACTIVITIES.Delete} the={ACL_RESOURCES.Dealers}>
      <div className="dealer-details-actions">
        <Button type="button" color="red" onClick={() => setIsDeleteConfirmOpen(true)}>
          {t("v8_delete", "Delete")}
          <Icon className="trash" />
        </Button>
      </div>
      <CustomConfirm
        type={CUSTOM_CONFIRM_TYPES.Danger}
        isOpen={isDeleteConfirmOpen}
        isLoading={isDeleteDealerPending}
        confirmMsg={t("v8_confirm_delete_dealer", "Are you sure that you want to delete {{dealerName}}? You can't undo this action.", { dealerName })}
        handleCancel={() => setIsDeleteConfirmOpen(false)}
        handleConfirm={() => deleteDealer(dealerId, { onSuccess: () => history.push(PATHS.DEALERS_DASHBOARD) })}
      />
    </Can>
  );
};
